import * as React from 'react';

/**
 * Renders a plain string; each `{phrase}` becomes a `<span>` with the given class (no HTML in resources).
 * Example: renderTextWithCurlyBold("Hello {world}", "my-emphasis") => "Hello " + <span class="my-emphasis">world</span>
 */
export function renderTextWithCurlyBold(text: string, emphasisSpanClassName: string): React.ReactNode {
    if (!text) {
        return null;
    }

    const re = /\{([^}]*)\}/g;
    const nodes: React.ReactNode[] = [];
    let lastIndex = 0;
    let key = 0;
    let m: RegExpExecArray | null;

    while ((m = re.exec(text)) !== null) {
        if (m.index > lastIndex) {
            nodes.push(<React.Fragment key={key++}>{text.slice(lastIndex, m.index)}</React.Fragment>);
        }

        nodes.push(
            <span key={key++} className={emphasisSpanClassName || undefined}>
                {m[1]}
            </span>
        );
        lastIndex = m.index + m[0].length;
    }

    if (lastIndex < text.length) {
        nodes.push(<React.Fragment key={key++}>{text.slice(lastIndex)}</React.Fragment>);
    }

    return <>{nodes}</>;
}
